import { Button, Form, Input, message, Select, Space } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router";
import { AdminPage } from "../../components/AdminPage";
import { getAdminAuthCallbackUrl } from "../../lib/env";
import { getAccessToken } from "../../lib/staff";
import { type AdminStaffRole, ROLE_LABEL } from "../../lib/staff-types";
import { getTrpcClient } from "../../lib/trpc";

type InviteFormValues = {
	email: string;
	role: AdminStaffRole;
};

export function StaffInvitePage() {
	const navigate = useNavigate();
	const [form] = Form.useForm<InviteFormValues>();
	const [submitting, setSubmitting] = useState(false);

	async function onFinish(values: InviteFormValues) {
		const accessToken = await getAccessToken();
		if (!accessToken) {
			message.error("サインインが必要です。");
			return;
		}

		setSubmitting(true);
		try {
			const result = await getTrpcClient(accessToken).admin.invite.mutate({
				email: values.email.trim(),
				role: values.role,
				redirectTo: getAdminAuthCallbackUrl(),
			});
			message.success(
				result.inviteEmailSent
					? `${result.email} に招待メールを送信しました`
					: `${result.email} をスタッフに登録しました`,
			);
			navigate("/staff");
		} catch (err) {
			message.error(
				err instanceof Error ? err.message : "招待に失敗しました。",
			);
		} finally {
			setSubmitting(false);
		}
	}

	return (
		<AdminPage
			title="スタッフ管理"
			subtitle="スタッフ招待"
			extra={
				<Space>
					<Button onClick={() => navigate("/staff")}>キャンセル</Button>
					<Button
						type="primary"
						loading={submitting}
						onClick={() => form.submit()}
					>
						招待
					</Button>
				</Space>
			}
		>
			<div style={{ padding: 24, maxWidth: 480 }}>
				<Form
					form={form}
					layout="vertical"
					onFinish={onFinish}
					initialValues={{ role: "viewer_no_pii" satisfies AdminStaffRole }}
				>
					<Form.Item
						label="メールアドレス"
						name="email"
						rules={[
							{ required: true, message: "メールアドレスを入力してください" },
							{ type: "email", message: "形式が正しくありません" },
						]}
					>
						<Input type="email" autoComplete="email" />
					</Form.Item>
					<Form.Item label="ロール" name="role" rules={[{ required: true }]}>
						<Select
							options={(Object.keys(ROLE_LABEL) as AdminStaffRole[]).map(
								(value) => ({
									value,
									label: ROLE_LABEL[value],
								}),
							)}
						/>
					</Form.Item>
				</Form>
			</div>
		</AdminPage>
	);
}
